export default __webpack_public_path__ + "static/media/iconXLS.aa2a5313.svg";